export const lastMessageTime = (time: string) => {
  if (!time) return '';
  const lastTime = new Date(time);
  const minutes = Math.round((new Date().getTime() - lastTime.getTime()) / 60000);
  if (minutes < 1) return 'Now';
  if (minutes < 60) return `${minutes}m`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${Math.round(minutes / 60)}h`;
  const days = Math.round(hours / 24);
  if (days < 30) return `${Math.round(hours / 24)}d`;
  return lastTime.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

/** lastMessageTime spelled out for a sentence: "5 min ago", "2 days ago", "now", "Jul 18". */
export const timeAgo = (time: string) => {
  const relative = lastMessageTime(time);
  const match = /^(\d+)([mhd])$/.exec(relative);
  if (!match) return relative === 'Now' ? 'now' : relative;
  const [, n, unit] = match;
  const word = unit === 'm' ? 'min' : unit === 'h' ? 'hr' : n === '1' ? 'day' : 'days';
  return `${n} ${word} ago`;
};
